/*
  Pokitrio-Redesign: fixiertes Bewertungs-Badge (snippets/pkt-bewertung-badge.liquid).
  * Sichtbar, sobald der Besucher am Hero vorbei ist (Startseite: Unterkante .pkt-hero), sonst nach 600 px.
  * Handy: blendet beim Runterscrollen aus, beim Hochscrollen ein (Klasse pkt-bw--weg).
  * ×: merkt sich das Schliessen in sessionStorage (try/catch, im privaten Modus kann der Zugriff werfen).
  * html.lock (Drawer, Suche, Warenkorb, Impact-Dialoge): CSS blendet es aus.
  * Footer im Bild (.pkt-ft, sonst footer/[role=contentinfo]): ausgeblendet (IntersectionObserver), damit es
    Zahlarten und Rechtslinks nicht verdeckt.
*/
(() => {
  const el = document.querySelector('[data-pkt-bewertung]');
  if (!el) return;
  const KEY = 'pkt-bewertung-zu';
  const SCHWELLE = 600;
  const mobil = window.matchMedia('(max-width: 699px)');
  let geschlossen = false;
  try { geschlossen = sessionStorage.getItem(KEY) === '1'; } catch (e) { /* privater Modus */ }
  if (geschlossen) { el.remove(); return; }

  let letzteY = window.scrollY;
  let wartet = false;
  let imFooter = false;
  const grenze = () => {
    const hero = document.querySelector('.pkt-hero');
    if (!hero) return SCHWELLE;
    const r = hero.getBoundingClientRect();
    return Math.max(r.bottom + window.scrollY - 1, 0);
  };
  const pruefen = () => {
    wartet = false;
    const y = window.scrollY;
    const sichtbar = y > grenze() && !imFooter;
    el.hidden = !sichtbar;
    if (sichtbar && mobil.matches) {
      if (y > letzteY + 4) el.classList.add('pkt-bw--weg');
      else if (y < letzteY - 4) el.classList.remove('pkt-bw--weg');
    } else {
      el.classList.remove('pkt-bw--weg');
    }
    letzteY = y;
  };
  const planen = () => { if (!wartet) { wartet = true; requestAnimationFrame(pruefen); } };
  const footer = document.querySelector('.pkt-ft') || document.querySelector('footer, [role="contentinfo"]');
  let obs = null;
  if (footer && 'IntersectionObserver' in window) {
    obs = new IntersectionObserver((eintraege) => {
      imFooter = eintraege[eintraege.length - 1].isIntersecting;
      planen();
    });
    obs.observe(footer);
  }
  window.addEventListener('scroll', planen, { passive: true });
  window.addEventListener('resize', planen);

  // ×: merken, Badge entfernen und alle Beobachter/Listener abbauen
  const zu = el.querySelector('[data-pkt-bewertung-zu]');
  if (zu) zu.addEventListener('click', () => {
    try { sessionStorage.setItem(KEY, '1'); } catch (e) { /* privater Modus */ }
    if (obs) obs.disconnect();
    window.removeEventListener('scroll', planen);
    window.removeEventListener('resize', planen);
    el.remove();
  });
  pruefen();
})();
